<h4 mat-dialog-title>Select Searchable Columns</h4>
<mat-dialog-content style="overflow: hidden;">
  <div *ngFor="let column of columns">
    <mat-checkbox [(ngModel)]="column.selected" class="capitalize">{{ formatCamelCase(column.name) }}</mat-checkbox>
  </div>
</mat-dialog-content>
<br />
<mat-divider></mat-divider>
<mat-dialog-actions class="push-right-sm" style="float:right">
  <button mat-button [mat-dialog-close]="true" matTooltip="Cancel" (click)="cancel()">CANCEL</button>
  <button mat-button [mat-dialog-close]="true" color="accent" (click)="apply()" matTooltip="Apply">APPLY</button>
</mat-dialog-actions>
